import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {userCheckinSchema} from "./event";

export const parishSchema = new schema.Entity(
    'parishes',
    {},
    {
        idAttribute: 'id',
    }
)

export const churchSchema = new schema.Entity(
    'churches',
    {},
    {
        idAttribute: 'idname',
    }
)

export const churchMassTimeSchema = new schema.Entity(
    'church_mass_time',
    {},
    {
        idAttribute: 'id',
    }
)

// Route::get('churches/church/{id}/get', 'ChurchController@getById');
export const church_getById_Api = {
    backend: `Route::get('churches/church/{id}/get', 'ChurchController@getById');`,
    root: API_ROOT_URL,
    path: '/churches/church/:id/get',
    method: 'GET',
    schema: churchSchema,
    transform: createTransform(churchSchema, 'data'),
}
// Route::get('churches/parish/{id}/get', 'ChurchController@getParishById');
export const parish_getById_Api = {
    backend: `Route::get('churches/parish/{id}/get', 'ParishController@getById');`,
    root: API_ROOT_URL,
    path: '/churches/parish/:id/get',
    method: 'GET',
    schema: parishSchema,
    transform: createTransform(parishSchema, 'data'),
}
// Route::get('churches/church/gets', 'ChurchController@getChurches');
export const church_getChurches_Api = {
    backend: `Route::get('churches/church/gets', 'ChurchController@getChurches');`,
    root: API_ROOT_URL,
    path: '/churches/church/gets',
    method: 'GET',
    fields: ['sort_by', 'public', 'active', 'error_status', 'keyword', 'archdiocese', 'diocese', 'deanery', 'parish',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id',
        'country_id', 'province_id', 'district_id', 'ward_id', 'church_type', 'latitude', 'longitude', 'no_parish'],
    paramsFields: ['sort_by', 'public', 'active', 'status', 'error_status', 'keyword', 'archdiocese', 'diocese', 'deanery', 'parish',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id',
        'country_id', 'province_id', 'district_id', 'ward_id', 'church_type', 'latitude', 'longitude', 'no_parish', 'is_pilgrimage_center', 'is_basilica', 'is_minor_basilica',
        'user_id'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}
// Route::get('churches/church/my-contribute', 'ChurchController@getMyContributedChurches');
export const church_getMyContributedChurches_Api = {
    backend: `Route::get('churches/church/my-contribute', 'ChurchController@getMyContributedChurches');`,
    root: API_ROOT_URL,
    path: '/churches/church/my-contribute',
    method: 'GET',
    fields: ['keyword'],
    paramsFields: ['keyword'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}

// Route::get('churches/church/contributors-leaderboard', 'ChurchController@getContributorsLeaderboard');
export const church_getContributorsLeaderboard_Api = {
    backend: `Route::get('churches/church/contributors-leaderboard', 'ChurchController@getContributorsLeaderboard');`,
    root: API_ROOT_URL,
    path: '/churches/church/contributors-leaderboard',
    method: 'GET',
    paramsFields: ['limit'],
}

// Route::get('churches/church/get-library-stats', 'ChurchController@getLibraryStats');
export const church_getLibraryStats_Api = {
    backend: `Route::get('churches/church/get-library-stats', 'ChurchController@getLibraryStats');`,
    root: API_ROOT_URL,
    path: '/churches/church/get-library-stats',
    method: 'GET',
}

export const church_fetchChurchWithMassTimes_Api = {
    backend: `Route::get('churches/church/fetch-church-with-mass-times', 'ChurchController@fetchChurchWithMassTimes');`,
    root: API_ROOT_URL,
    path: '/churches/church/fetch-church-with-mass-times',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword', 'language', 'start_time', 'sunday_mass', 'from_time', 'to_time', 'start_in', 'day_of_week', 'weekdays',
        'timezone_offset_in_hours', 'latitude', 'longitude',
        'archdiocese', 'diocese', 'deanery', 'parish', 'church_type',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id',
        'country_id', 'province_id', 'district_id', 'ward_id', 'is_pilgrimage_center', 'is_minor_basilica', 'is_basilica', 'church_type'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}

// Route::get('churches/parish/gets', 'ParishController@getParishes');
export const church_getParishes_Api = {
    backend: `Route::get('churches/parish/gets', 'ParishController@getParishes');`,
    root: API_ROOT_URL,
    path: '/churches/parish/gets',
    method: 'GET',
    fields: ['sort_by', 'keyword',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id', 'no_church'],
    paramsFields: ['sort_by', 'keyword',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id', 'no_church'],
    schema: parishSchema,
    transform: createListTransform(parishSchema),
}
// Route::get('churches/mass-time/{id}/get', 'ChurchController@getChurchMassTimeById');
export const church_getChurchMassTimeById_Api = {
    backend: `Route::get('churches/mass-time/{id}/get', 'ChurchController@getChurchMassTimeById');`,
    root: API_ROOT_URL,
    path: '/churches/mass-time/:id/get',
    method: 'GET',
    schema: churchMassTimeSchema,
    transform: createTransform(churchMassTimeSchema, 'data'),
}
// Route::get('churches/mass-time/gets', 'ChurchController@getChurchMassTimes');
export const church_getChurchMassTimes_Api = {
    backend: `Route::get('churches/mass-time/gets', 'ChurchController@getChurchMassTimes');`,
    root: API_ROOT_URL,
    path: '/churches/mass-time/gets',
    method: 'GET',
    fields: ['sort_by', 'keyword', 'language', 'start_time', 'sunday_mass', 'from_time', 'to_time', 'start_in', 'day_of_week', 'weekdays',
        'timezone_offset_in_hours', 'latitude', 'longitude',
        'archdiocese', 'diocese', 'deanery', 'parish', 'church_type',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id',
        'country_id', 'province_id', 'district_id', 'ward_id'],
    paramsFields: ['sort_by', 'keyword', 'language', 'start_time', 'sunday_mass', 'from_time', 'to_time', 'start_in', 'day_of_week', 'weekdays',
        'timezone_offset_in_hours', 'latitude', 'longitude',
        'archdiocese', 'diocese', 'deanery', 'parish', 'church_type',
        'archdiocese_id', 'diocese_id', 'deanery_id', 'parish_id',
        'country_id', 'province_id', 'district_id', 'ward_id'],
    schema: churchMassTimeSchema,
    transform: createListTransform(churchMassTimeSchema),
}
// Route::get('churches/church/{id}/get-mass-times', 'ChurchController@getMassTimesByChurch');
export const church_getMassTimesByChurch_Api = {
    backend: `Route::get('churches/church/{id}/get-mass-times', 'ChurchController@getMassTimesByChurch');`,
    root: API_ROOT_URL,
    path: '/churches/church/:id/get-mass-times',
    method: 'GET',
    fields: ['keyword'],
    schema: churchMassTimeSchema,
    transform: createListTransform(churchMassTimeSchema),
}

// Route::post('churches/church/create-new', 'ChurchController@createChurch');
export const church_createChurch_Api = {
    backend: `Route::post('churches/church/create-new', 'ChurchController@createChurch');`,
    root: API_ROOT_URL,
    path: '/churches/church/create-new',
    method: 'POST',
    paramsFields: [],
    schema: churchSchema,
    transform: createTransform(churchSchema, 'data'),
}
// Route::post('churches/church/{id}/update', 'ChurchController@updateChurch');
export const church_updateChurch_Api = {
    backend: `Route::post('churches/church/{id}/update', 'ChurchController@updateChurch');`,
    root: API_ROOT_URL,
    path: '/churches/church/:id/update',
    method: 'POST',
    paramsFields: [],
    schema: churchSchema,
    transform: createTransform(churchSchema, 'data'),
}
// Route::post('churches/church/{id}/delete', 'ChurchController@deleteChurch');
export const church_deleteChurch_Api = {
    backend: `Route::post('churches/church/{id}/delete', 'ChurchController@deleteChurch');`,
    root: API_ROOT_URL,
    path: '/churches/church/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: churchSchema,
    transform: createTransform(churchSchema, 'data'),
}
// Route::post('churches/church/{id}/mass-time/create-new', 'ChurchController@createChurchMassTime');
export const church_createChurchMassTime_Api = {
    backend: `Route::post('churches/church/{id}/mass-time/create-new', 'ChurchController@createChurchMassTime');`,
    root: API_ROOT_URL,
    path: '/churches/church/:church_id/mass-time/create-new',
    method: 'POST',
    paramsFields: [],
    schema: churchMassTimeSchema,
    transform: createTransform(churchMassTimeSchema, 'data'),
}
// Route::post('churches/mass-time/{id}/update', 'ChurchController@updateChurchMassTime');
export const church_updateChurchMassTime_Api = {
    backend: `Route::post('churches/mass-time/{id}/update', 'ChurchController@updateChurchMassTime');`,
    root: API_ROOT_URL,
    path: '/churches/mass-time/:id/update',
    method: 'POST',
    paramsFields: [],
    schema: churchMassTimeSchema,
    transform: createTransform(churchMassTimeSchema, 'data'),
}
// Route::post('churches/mass-time/{id}/delete', 'ChurchController@deleteChurchMassTime');
export const church_deleteChurchMassTime_Api = {
    backend: `Route::post('churches/mass-time/{id}/delete', 'ChurchController@deleteChurchMassTime');`,
    root: API_ROOT_URL,
    path: '/churches/mass-time/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: churchMassTimeSchema,
    transform: createTransform(churchMassTimeSchema, 'data'),
}


// Route::post('churches/parish/create-new', 'ParishController@createParish');
export const parish_createParish_Api = {
    backend: `Route::post('churches/parish/create-new', 'ParishController@createParish');`,
    root: API_ROOT_URL,
    path: '/churches/parish/create-new',
    method: 'POST',
    paramsFields: [],
    schema: parishSchema,
    transform: createTransform(parishSchema, 'data'),
}
// Route::post('churches/parish/{id}/update', 'ParishController@updateParish');
export const parish_updateParish_Api = {
    backend: `Route::post('churches/parish/{id}/update', 'ParishController@updateParish');`,
    root: API_ROOT_URL,
    path: '/churches/parish/:id/update',
    method: 'POST',
    paramsFields: [],
    schema: parishSchema,
    transform: createTransform(parishSchema, 'data'),
}
// Route::post('churches/parish/{id}/delete', 'ParishController@deleteParish');
export const parish_deleteParish_Api = {
    backend: `Route::post('churches/parish/{id}/delete', 'ParishController@deleteParish');`,
    root: API_ROOT_URL,
    path: '/churches/parish/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: parishSchema,
    transform: createTransform(parishSchema, 'data'),
}

export const church_getRecommendInfos_Api = {
    backend: `Route::get('churches/get-recommend-info', 'AppController@getChurchesInfo');`,
    root: API_ROOT_URL,
    path: '/churches/get-recommend-info',
    method: 'GET',
}

export const church_checkin_getAllCheckinsByOwner_Api = {
    backend: `Route::get('checkins/{owner_type}/{owner_id}/get-all-by-owner', 'EventCheckinController@getAllCheckinsByOwner');`,
    root: API_ROOT_URL,
    path: '/checkins/:owner_type/:owner_id/get-all-by-owner',
    method: 'GET',
    paramsFields: [],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}

export const church_getNearbyChurches_Api = {
    backend: `Route::get('churches/get-nearby-churches', 'ChurchController@getNearbyChurches');`,
    root: API_ROOT_URL,
    path: '/churches/get-nearby-churches',
    method: 'GET',
    paramsFields: ['limit'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}

export const church_getNearbyChurchesByDistance_Api = {
    backend: `Route::get('churches/{id}/get-nearby-churches-bydistance', 'ChurchController@getNearbyChurchesByDistance');`,
    root: API_ROOT_URL,
    path: '/churches/:id/get-nearby-churches-bydistance',
    method: 'GET',
    paramsFields: ['limit'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}


export const checkin_getCheckInDetail_Api = {
    backend: `Route::get('checkins/{type}/{id}/get-visits', 'ChurchVisitController@getCheckInDetail');`,
    root: API_ROOT_URL,
    path: '/checkins/:type/:id/get-visits',
    method: 'GET',
    schema: userCheckinSchema,
    transform: createListTransform(userCheckinSchema),
}

export const checkin_getCheckInDistinct_Api = {
    backend: `Route::get('checkins/get-distincts', 'ChurchVisitController@getCheckInDistinct');`,
    root: API_ROOT_URL,
    path: '/checkins/get-distincts',
    method: 'GET',
    paramsFields: ['province_id', 'keyword', 'sort_by'],
    schema: userCheckinSchema,
    transform: createListTransform(userCheckinSchema),
}

export const checkin_getChurchCheckInStats_Api = {
    backend: `Route::get('checkins/get-checked-in-stats', 'ChurchVisitController@getChurchCheckInStats');`,
    root: API_ROOT_URL,
    path: '/checkins/get-checked-in-stats',
    method: 'GET',
}

// Route::get('churches/church/get-nearby-checkin', 'ChurchController@getChurchesNearby');
export const church_getNearbyCheckin_Api = {
    backend: `Route::get('churches/church/get-nearby-checkin', 'ChurchController@getChurchesNearby');`,
    root: API_ROOT_URL,
    path: '/churches/church/get-nearby-checkin',
    method: 'GET',
    paramsFields: ['latitude', 'longitude', 'radius'],
}

// Route::get('lookup/church/get-by-filter', 'LookupController@getByObjectTypes');
export const church_getLookup_Api = {
    backend: `Route::get('lookup/church/get-by-filter', 'LookupController@getByObjectTypes');`,
    root: API_ROOT_URL,
    path: '/lookup/church/get-by-filter',
    method: 'GET',
    paramsFields: ['keyword', 'diocese_id', 'province_id'],
    schema: churchSchema,
    transform: createListTransform(churchSchema),
}